import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaginaNoEncontrada404Component } from './components/shared/pagina-no-encontrada404/pagina-no-encontrada404.component';
import { AuthService } from './servicios/auth.service';

const routes: Routes = [
  { path: '', redirectTo: 'inicio', pathMatch: 'full' },
  { path: 'inicio', loadChildren: () => import('./components/auth/auth.module').then(m => m.AuthModule) },
  {
    path: 'sistema',
     canActivate: [AuthService],
    loadChildren: () => import('./components/sistema/sistema.module').then(m => m.SistemaModule)
  },
  { path: '**', component: PaginaNoEncontrada404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
